import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import React from 'react';

interface SidebarItemProps {
  icon: LucideIcon;
  label: string;
  active?: boolean;
  onClick: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  icon: Icon,
  label,
  active,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        visibility: 'visible',
        opacity: 1,
        position: 'relative',
        zIndex: 1,
      }}
      className={cn(
        'flex items-center w-full px-2 py-1 text-sm font-medium rounded-md',
        active
          ? 'bg-gray-100 text-gray-900'
          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
      )}
    >
      <Icon className="w-5 h-5 mr-3" />
      {label}
    </button>
  );
};

export default SidebarItem;